/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Lot_Trace_ActionInputs */

const vi_tea_lot_trace_action = /** @type {(inputs: Tea_Lot_Trace_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo mã truy xuất`)
};

/**

* @param {Tea_Lot_Trace_ActionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_lot_trace_action = /** @type {((inputs?: Tea_Lot_Trace_ActionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Lot_Trace_ActionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_lot_trace_action(inputs)
});